import AccessibleFakeButton from './AccessibleFakeButton';
import injectInk from '../Inks/injectInk';

export default injectInk(AccessibleFakeButton);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-md/es/Helpers/AccessibleFakeInkedButton.js
// module id = 32
// module chunks = 0